import { useQuery } from '@tanstack/react-query';
import {
  getLabourItemGroups,
  LabourItemGroup,
} from '../api/labourItemGroupsApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { labourGroupKeys } from './labourGroupKeys';

export const useLabourItemGroups = (enabled: boolean = true) => {
  const token = useAuthStore(state => state.token);

  return useQuery<LabourItemGroup[]>({
    queryKey: labourGroupKeys.lists(),
    queryFn: async () => {
      if (!token) {
        return [];
      }
      return await getLabourItemGroups();
    },
    placeholderData: previousData => previousData,
    enabled: enabled && !!token,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
